import { Card, Typography, Table, Flex } from "antd";
import React from "react";

import "./styles.css";

export default function TopTreatmentsApprovalVSPaymentComparison() {
  const columns = [
    {
      title: "Treatment",
      dataIndex: "treatment",
      key: "treatment",
    },
    {
      title: "Approval",
      dataIndex: "approval",
      key: "approval",
      render: (text) => `$${text.toLocaleString()}`,
    },
    {
      title: "Payment",
      dataIndex: "payment",
      key: "payment",
      render: (text) => `$${text.toLocaleString()}`,
    },
  ];

  const data = [
    { key: "1", treatment: "1234 - Root Canal", approval: 1500, payment: 1200 },
    { key: "2", treatment: "1234 - Root Canal", approval: 1500, payment: 1200 },
    { key: "3", treatment: "1991 - Root Canal", approval: 1200, payment: 1000 },
  ];

  return (
    <Card style={{ width: "100%", height: 350 }}>
      <Flex gap={20} vertical>
        <Typography.Title level={4}>Top Treatments Approval vs. Payment Comparison</Typography.Title>
        <Table
          columns={columns}
          dataSource={data}
          className="fixed-body-height-scroll-top-treatments-approval-vs-payment-comparison"
          pagination={false}
          sticky
        />
      </Flex>
    </Card>
  );
}
